import type { PixelSprite } from '../types.js';
import { sprites as bakery } from './bakery.js';
import { sprites as choga } from './choga.js';
import { sprites as church } from './church.js';
import { sprites as churchWinter } from './churchWinter.js';
import { sprites as doghouse } from './doghouse.js';
import { sprites as garden } from './garden.js';
import { sprites as hanok } from './hanok.js';
import { sprites as hanokGate } from './hanokGate.js';
import { sprites as house } from './house.js';
import { sprites as houseB } from './houseB.js';
import { sprites as houseBWinter } from './houseBWinter.js';
import { sprites as houseWinter } from './houseWinter.js';
import { sprites as hut } from './hut.js';
import { sprites as igloo } from './igloo.js';
import { sprites as koreanWatermill } from './koreanWatermill.js';
import { sprites as laundry } from './laundry.js';
import { sprites as onggi } from './onggi.js';
import { sprites as pavilion } from './pavilion.js';
import { sprites as shrine } from './shrine.js';
import { sprites as stable } from './stable.js';
import { sprites as stoneWall } from './stoneWall.js';
import { sprites as tavern } from './tavern.js';
import { sprites as tent } from './tent.js';
import { sprites as wagon } from './wagon.js';
import { sprites as watermill } from './watermill.js';
import { sprites as well } from './well.js';
import { sprites as windmill } from './windmill.js';
export const sprites: Readonly<Record<string, readonly PixelSprite[]>> = {
  bakery,
  choga,
  church,
  churchWinter,
  doghouse,
  garden,
  hanok,
  hanokGate,
  house,
  houseB,
  houseBWinter,
  houseWinter,
  hut,
  igloo,
  koreanWatermill,
  laundry,
  onggi,
  pavilion,
  shrine,
  stable,
  stoneWall,
  tavern,
  tent,
  wagon,
  watermill,
  well,
  windmill,
};
